<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6666 9.16659H6.49992L11.1666 4.49992L9.99992 3.33325L3.33325 9.99992L9.99992 16.6666L11.1666 15.4999L6.49992 10.8333H16.6666V9.16659Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IcArrowLeft',
} as DefineComponent
</script>
